// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"_2trbjyGN_WgNSl0h00dwGr","open":"UVJ1C5EiEkEUygTg3-Kfm"};